import { Jwt } from 'lib/types';

export const USER_LOCAL_STORAGE = 'user';

const clearToken = () => {
    sessionStorage.removeItem(USER_LOCAL_STORAGE);
};

const parseToken = (token: string) => {
    try {
        return JSON.parse(token) as Jwt;
    } catch {
        clearToken();
        return null;
    }
};

const getToken = (): Jwt | null => {
    const token = sessionStorage.getItem(USER_LOCAL_STORAGE);
    return token === null ? null : parseToken(token);
};

const setToken = (token: string | null, tokenExpiration: number | null) => {
    if (token === null || tokenExpiration === null) {
        clearToken();
    } else {
        sessionStorage.setItem(USER_LOCAL_STORAGE, JSON.stringify({ token, tokenExpiration }));
    }
};

export const sessionService = {
    getToken,
    setToken,
    clearToken
};
